export type NotificationNavigation =
  | { mode: "in-app"; path: string }
  | { mode: "assign"; url: string };

export function isHostnameSysigreja(hostname: string): boolean {
  const host = hostname.trim().toLowerCase().replace(/\.$/, "");
  return host === "sysigreja.com" || host.endsWith(".sysigreja.com");
}

export function asAbsoluteHttpUrl(raw: string): URL | null {
  const value = raw.trim();
  if (!value) return null;

  const candidates: string[] = [];
  if (/^https?:\/\//i.test(value)) candidates.push(value);
  else if (value.startsWith("//")) candidates.push(`https:${value}`);
  else if (/^[a-z0-9][a-z0-9.-]*\.[a-z]{2,}([/:?#].*)?$/i.test(value)) {
    candidates.push(`https://${value}`);
  }

  for (const candidate of candidates) {
    try {
      return new URL(candidate);
    } catch {
      /* tenta o próximo formato */
    }
  }
  return null;
}

/**
 * Push/deeplink de site (ex.: recon.sysigreja.com/o-informativo) não pode virar
 * só o path no PWA de sysigreja.com — isso cai em /:login e abre a listagem de eventos.
 */
export function resolveNotificationNavigation(
  link: string | null | undefined,
  currentOrigin?: string,
): NotificationNavigation {
  if (!link?.trim()) {
    return { mode: "in-app", path: "/sistema" };
  }

  const trimmed = link.trim();
  if (trimmed.startsWith("/") && !trimmed.startsWith("//")) {
    return { mode: "in-app", path: trimmed };
  }

  const parsed = asAbsoluteHttpUrl(trimmed);
  if (!parsed || !isHostnameSysigreja(parsed.hostname)) {
    return { mode: "in-app", path: "/sistema" };
  }

  const origin =
    currentOrigin ?? (typeof window !== "undefined" ? window.location.origin : "");
  let sameOrigin = false;
  if (origin) {
    try {
      sameOrigin = parsed.origin === new URL(origin).origin;
    } catch {
      sameOrigin = false;
    }
  }

  if (parsed.pathname.startsWith("/sistema") || sameOrigin) {
    return {
      mode: "in-app",
      path: `${parsed.pathname}${parsed.search}${parsed.hash}` || "/sistema",
    };
  }

  return { mode: "assign", url: parsed.toString() };
}

export function openNotificationLink(
  navigate: (path: string) => void,
  link: string | null,
): void {
  const dest = resolveNotificationNavigation(link);
  if (dest.mode === "assign") {
    window.location.assign(dest.url);
    return;
  }
  navigate(dest.path);
}
